import { STeamGrid, STeamGridWrapper } from 'components/content/about/aboutTeam/styled'
import { ReactNode } from 'react'

export function TeamGrid(props: { children: ReactNode; footer?: ReactNode }) {
  return (
    <STeamGridWrapper>
      <STeamGrid>{props.children}</STeamGrid>
      {props.footer}
    </STeamGridWrapper>
  )
}
